<template>
  <div class="level" style="color#000;background:#fff;">
    <div class="home_tit">
      <div
        class="home_tit_top"
        style="background: var(--bg-color); padding: 0 12px"
      >
        <!-- <div class="home_tit_middle">发现</div>-->
        <div
          style="
            flex: 1;
            border: 1px solid #dfdfdf;
            display: flex;
            align-items: center;
            background: #fff;
            height: 30px;
            border-radius: 20px;
            padding: 0 10px;
          "
        >
          <img
            src="../../assets/images/new/sou.png"
            style="width: 16px; height: 16px; margin-right: 4px"
            alt=""
          />
          <input
            type="text"
            style="font-size: 13px"
            :placeholder="$t('m.fx_span1')"
          />
        </div>
        <div class="home_tit_right">
          <img @click="goTo(112)" src="../../assets/images/new/kefu.png" />
        </div>
      </div>
    </div>

    <van-tabs
      v-model="active"
      v-if="newsList.length > 0"
      style="margin-top: 50px; padding-top: 0px"
      @click="onClickTab"
    >
      <van-tab
        v-for="(items, indexs) in newsList"
        :key="indexs"
        :title="items.name"
      >
        <div
          class="level_con_item"
          style="margin-top: 5px; border-radius: 8px; overflow: hidden"
        >
          <div
            v-if="items.link == ''"
            style="padding: 10px 0px; border-bottom: 1px solid #eee"
            v-for="(item, index) in items.list"
            :key="index"
            @click="
              $router.push({ name: 'article_detail', query: { id: item.id } })
            "
          >
            <div style="display: flex; align-items: center" v-if="index == 0">
              <img
                :src="item.image"
                style="border-radius: 10px; width: 100%; height: 165px"
                alt=""
              />
            </div>
            <div style="display: flex; align-items: center" v-else>
              <img
                :src="item.image"
                style="border-radius: 6px; width: 142px; height: 80px"
                alt=""
              />
              <div style="flex: 1; margin-left: 10px">
                <div
                  class="line-clamp2"
                  style="
                    font-size: 14px;
                    height: 50px;
                    line-height: 25px;
                    color: #000;
                    font-weight: bold;
                  "
                >
                  {{ item.title }}
                </div>

                <div
                  style="
                    display: flex;
                    align-items: center;
                    color: #666;
                    font-size: 10px;
                    height: 20px;
                    margin-top: 15px;
                  "
                >
                  <!--                  <span style="margin-right: 25px">{{ $t("m.fx_span3") }}</span>-->
                </div>
              </div>
            </div>
          </div>

          <iframe
            v-else
            style="
              position: absolute;
              top: 0px;
              height: 100%;
              padding-top: 45px;
              left: 0;
              right: 0;
              padding-bottom: 40px;
              width: 100%;
            "
            v-bind:src="items.link"
          ></iframe>
        </div>
        <div style="height: 70px"></div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
var vm = null;
import request from "@utils/request";
// import { getArticleList } from "../../api/public";
import "vant/lib/button/style";

export default {
  components: {},

  data: function() {
    return {
      active: 0,
      gglist: [],
      newsList: []
    };
  },
  mounted() {
    request
      .post(
        "/api/v1/article/cat/all",
        {},
        {
          login: false
        }
      )
      .then(res => {
        this.newsList = res.data.data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  created() {
    vm = this;
  },
  computed: {
    createDate: function() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        return h + ":" + m;
      };
    }
  },
  methods: {
    onClickTab(e) {
      let link = this.newsList[e];
    },
    goTo(e) {
      if (e == 111) {
        this.$router.push({
          path: "/customerService"
        });
      } else if (e == 112) {
        this.$router.push({
          path: "/user"
        });
      }
    },
    getArticleList() {
      request
        .post(
          "/api/v1/article/cat/all",
          {},
          {
            login: false
          }
        )
        .then(res => {
          this.newsList = res.data.data;
          console.log(res.data.data);
        });
    }
  }
};
</script>

<style scoped lang="less">
body {
  background: #fff !important;
}

.home_line {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 15px;
}

/deep/ .swiper-pagination-bullet {
  border: 2px solid #fff;
  background: #dfdfdf;
}

/deep/ .swiper-pagination-bullet-active {
  // 这以下的代码是你需要的
  background: #fff;
  border: 0px solid #fff;
}

.home_line img {
  border-radius: 5px;
  height: 130px;
  flex: 1;
  // margin-right: 10px;
}

.home_swiper {
  width: 100%;
  height: 190px;
}

.home_swiper swiper-slide {
  width: 100%;
  height: 190px;
}

.home_swiper {
  height: 190px;
}

.banner_img {
  width: 100%;
  height: 190px;
}

.home_line img:last-child {
  margin-right: 0px;
}

.zuoce {
  // max-width: 100px;
  overflow: hidden;
  /*超出部分隐藏*/
  white-space: nowrap;
  /*禁止换行*/
  text-overflow: ellipsis;
  /*省略号*/
}

.zuoce1 {
  color: #666;
  font-size: 10px;
}

.level_con_item {
  padding: 0 15px;
  padding-top: 43px;
  min-height: 80vh;
}

.line-clamp2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.line-clamp1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.van-list {
  ::v-deep .van-list__loading {
    color: #969799;
    font-size: 14px;
    line-height: 50px;
    text-align: center;
  }

  ::v-deep .van-list__finished-text {
    color: #969799;
    font-size: 14px;
    line-height: 50px;
    text-align: center;
  }

  ::v-deep .van-list__error-text {
    color: #969799;
    font-size: 14px;
    line-height: 50px;
    text-align: center;
  }
}

.level_con_news_left {
  width: 66%;
  padding: 15px 0;
}

.level_con_news_left p:first-child {
  font-size: 16px;
  font-family: Microsoft YaHei, serif;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}

.level_con_news_left p:last-child {
  font-size: 13px;
  font-family: Microsoft YaHei, serif;
  font-weight: 400;
  color: #999999;
  line-height: 36px;
}

.level_con_news_left .wenben {
  margin-top: 10px;
  font-size: 11px;
  font-family: Microsoft YaHei, serif;
  font-weight: 400;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.level_con_news {
  background-color: #ffffff;
  display: flex;
  // align-items: center;
  padding: 6px 15px;
  margin-top: 10px;
}

.jiangli_top {
  color: #ffffff;
  width: 100%;
  height: 50px;
  background-color: #ffffff;
}

.jiangli_top p {
  font-weight: bold;
}

.level_con {
  padding: 10px 15px;
  padding-top: 0;
}

.level_con_top {
  width: 100%;
  height: 143px;
}

.level_con_top img {
  width: 100%;
  height: 100%;
}

.home_msg_con {
  margin-left: 15px;
  width: 85%;
  font-size: 14px;
  line-height: 21px;
  height: 100%;
}

.home_msg img {
  width: 37px;
  height: 37px;
}

.level_con_news_right {
  width: 120px;
  height: 120px;
}

.level_con_news_right img {
  width: 100%;
  height: 100%;
}

.home_msg {
  background-color: #ffffff;
  margin-top: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 14px 14px;
  height: 70px;
}

.home_block {
  display: flex;
  justify-content: space-between;
  // margin-top: 10px;
  padding: 0 0px;
  padding-bottom: 10px !important;
}

.home_block_list {
  width: 25%;
  margin-top: 15px;
}

.home_block_list p {
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 7px;
}

.home_block_list_img {
  width: 30px;
  height: 30px;
  margin: 0 auto;
  display: block;
}

.home_block_list_img img {
  width: 100%;
  height: 100%;
}

.home_tit {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
}

.home_tit_top {
  height: 50px;

  display: flex;
  align-items: center;
}

.home_swiper {
  width: 100%;
  height: 190px;
}

.home_swiper swiper-slide {
  width: 100%;
  height: 190px;
}

.home_swiper {
  height: 190px;
}

.banner_img {
  width: 100%;
  height: 190px;
}

.home_tit_left {
  width: 25%;
  display: flex;
  align-items: center;
}

.home_tit_left img {
  width: 23px;
  height: 23px;
}

.home_tit_left div {
  margin: 0 20px;
  color: #333;
  font-size: 16px;
}

.home_tit_middle {
  width: 70px;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  padding-right: 0;
  margin: 0 0px;
  color: #333;
  font-weight: bold;
  font-size: 22px;
}

.home_tit_middle img {
  width: 15px;
  height: 15px;
  margin-left: 7px;
}

.home_tit_right {
  padding-right: 0px;
  width: 30px;
  display: flex;
  align-items: center;
  color: #333;
  flex-direction: row-reverse;

  font-size: 15px;
  font-weight: bold;
}

.home_tit_right img {
  width: 22px;
  height: 22px;
  margin-left: 10px;
}

/deep/ .van-tabs__nav {
  background-color: #fff !important;
  overflow: scroll;
}

/deep/ .van-tab {
  height: 20px;
  font-weight: 600;
  font-size: 14px;
  border-right: 0px solid #eee;
  flex: none;
  // min-width: 20%;
  color: #666;
  // margin-right: 10px;
}

/deep/ .van-tabs__wrap--scrollable .van-tab {
  // padding: 0;
}

.van-tab--active .van-tab:last-child {
  border-right: 0px solid #fff !important;
}

/deep/ .van-tab--active {
  color: var(--bg-color);
  font-size: 15px;
}

/deep/ .van-tabs__nav--line {
  padding: 0px 10px;
  height: 50px;
  box-sizing: border-box;
}

/deep/ .van-tabs__nav--complete {
  padding-left: 3px;
}

/deep/ .van-tabs__wrap {
  width: 100%;
  padding-top: 10px;
  height: 48px;
  position: fixed;
  background: #fff;
}

/deep/ .van-tabs__line {
  min-width: 5%;
  top: 28px;
  background: var(--bg-color);
  width: 20px;
}
</style>
